import { ofType } from "redux-observable";
import { switchMap, catchError, map } from "rxjs/operators";
import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ActionsObservable } from "redux-observable";
import { toast } from "react-toastify";
import { API_URL } from "../../config/settings";
import { Headers } from "../../utilites/Headers";
import { CommunityStats } from "../../actions/appExpandedActions/communities";

// Community Aggregated Stats Epic
export const getCommunityAggregatedStatsEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_COMMUNITY_AGGREGATED_STATS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/aggregated-stats`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Community Aggregated Stats Response:", response);
            obs.next({
              type: CommunityStats.GET_COMMUNITY_AGGREGATED_STATS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Community Aggregated Stats Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community stats");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Community Notices Epic
export const getNeighborsNoticesEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_NEIGHBORS_NOTICES),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/notices/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || payload?.period?.startDate || "",
          endDate: payload?.endDate || payload?.period?.endDate || "",
          createdBy: payload?.createdBy || "",
          community: payload?.community || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Community Notices Response:", response);
            obs.next({
              type: CommunityStats.GET_NEIGHBORS_NOTICES_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Community Notices Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community notices");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Fix calendar events endpoint
export const getNeighborsCalendarEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_NEIGHBORS_CALENDAR),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/events/list`, // ✅ Fixed endpoint
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Community Calendar Response:", response);
            obs.next({
              type: CommunityStats.GET_NEIGHBORS_CALENDAR_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Community Calendar Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community calendar");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Community Files Epic
export const getNeighboursFilesEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_NEIGHBOURS_FILES),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/files/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Community Files Response:", response);
            obs.next({
              type: CommunityStats.GET_NEIGHBOURS_FILES_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Community Files Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community files");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Fix services endpoint
export const getNeighboursServicesEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_NEIGHBORS_SERVICES),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/assistant-queries/list`, // ✅ Fixed endpoint
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Community Services Response:", response);
            obs.next({
              type: CommunityStats.GET_NEIGHBORS_SERVICES_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Community Services Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community services");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Community Meetings Epic
export const getNeighboursMeetingsEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_NEIGHBORS_MEETINGS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/meetings/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Community Meetings Response:", response);
            obs.next({
              type: CommunityStats.GET_NEIGHBORS_MEETINGS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Community Meetings Error:", err);
            obs.next({
              type: CommunityStats.GET_NEIGHBORS_MEETINGS_ERROR,
              payload: err,
            });
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community meetings");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Community Wallets Epic
export const getNeighboursWalletsEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_NEIGHBORS_WALLETS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/wallets/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Community Wallets Response:", response);
            obs.next({
              type: CommunityStats.GET_NEIGHBORS_WALLETS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Community Wallets Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community wallets");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Community Polls Epic
export const getNeighborsPollsEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_NEIGHBORS_POLLS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/polls/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Community Polls Response:", response);
            obs.next({
              type: CommunityStats.GET_NEIGHBORS_POLLS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Community Polls Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community polls");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Fix payments endpoint
export const getNeighborsPaymentsEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_NEIGHBORS_PAYMENTS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/funds/list`, // ✅ Fixed endpoint
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Community Payments Response:", response);
            obs.next({
              type: CommunityStats.GET_NEIGHBORS_PAYMENTS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Community Payments Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community payments");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Add missing community chats epic
export const getCommunityChatsEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_COMMUNITY_CHATS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/chats/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          createdBy: payload?.createdBy || "",
          community: payload?.community || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: CommunityStats.GET_COMMUNITY_CHATS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community chats");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

export const getCommunityTransactionsEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_COMMUNITY_TRANSACTIONS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/transactions/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          createdBy: payload?.createdBy || "",
          community: payload?.community || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: CommunityStats.GET_COMMUNITY_TRANSACTIONS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: CommunityStats.GET_COMMUNITY_TRANSACTIONS_ERROR,
              payload: err,
            });
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community transactions");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

export const getCommunityBankAccountsEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_COMMUNITY_BANK_ACCOUNTS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/bank-accounts/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          createdBy: payload?.createdBy || "",
          community: payload?.community || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: CommunityStats.GET_COMMUNITY_BANK_ACCOUNTS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community bank accounts");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

export const getCommunityFoldersEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_COMMUNITY_FOLDERS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/folders/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          createdBy: payload?.createdBy || "",
          community: payload?.community || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: CommunityStats.GET_COMMUNITY_FOLDERS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community folders");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

export const getCommunityMembersEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_COMMUNITY_MEMBERS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/members/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          createdBy: payload?.createdBy || "",
          community: payload?.community || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: CommunityStats.GET_COMMUNITY_MEMBERS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community members");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

export const getCommunityAdministratorsEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_COMMUNITY_ADMINISTRATORS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/administrators/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          createdBy: payload?.createdBy || "",
          user: payload?.user || "",
          community: payload?.community || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: CommunityStats.GET_COMMUNITY_ADMINISTRATORS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community administrators");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

export const getCommunityPrintOrdersEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_COMMUNITY_PRINT_ORDERS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/print-orders/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          createdBy: payload?.createdBy || "",
          community: payload?.community || "",
          lang: payload?.lang || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: CommunityStats.GET_COMMUNITY_PRINT_ORDERS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community print orders");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Add missing polls epic
export const getCommunityPollsEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_COMMUNITY_POLLS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/polls/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          createdBy: payload?.createdBy || "",
          community: payload?.community || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: CommunityStats.GET_COMMUNITY_POLLS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community polls");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Add missing funds epic
export const getCommunityFundsEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_COMMUNITY_FUNDS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-communities/funds/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          createdBy: payload?.createdBy || "",
          community: payload?.community || "",
          lang: payload?.lang || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: CommunityStats.GET_COMMUNITY_FUNDS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load community funds");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Community Utility Bills Epic
export const getCommunityUtilityBillsEpic = (action$) =>
  action$.pipe(
    ofType(CommunityStats.GET_COMMUNITY_UTILITY_BILLS),
    switchMap(({ payload }) => {
      return ajax({
        url: `${API_URL}/admin/app-communities/utility-bills/payments/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: payload,
      }).pipe(
        map((response) => {
          return {
            type: CommunityStats.GET_COMMUNITY_UTILITY_BILLS_SUCCESS,
            payload: response.response.payload,
          };
        }),
        catchError((err) => {
          console.error("❌ Error in getCommunityUtilityBillsEpic:", err);
          toast.error(err?.response?.error || "Failed to load utility bills");
          return of({
            type: CommunityStats.GET_COMMUNITY_UTILITY_BILLS_SUCCESS,
            payload: { docs: [], totalPages: 0 },
          });
        })
      );
    })
  );